import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8081',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'smartgreen',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'smartgreen-frontend'
});

export default keycloak;
